/* eslint-disable import/extensions */
import IconBase from './assetsMenu.json'

const icon = () => IconBase

export default icon
